import { createClient, editClient } from '../../_services/client.service';
import { getCompany } from '../../_utils/storage_handler';
import { 
    buildCreateClientBody,
    cleanInputs,
    validateCreateClient
} from './create_client.input';

export const createClientEvent = async () => {
    let body = buildCreateClientBody(getCompany());
    validateCreateClient(body);
    let res = await createClient(body);
    if(res.ok){
        cleanInputs();
    } else {
        throw new Error(res.error);
    }
    
    return res;
}

export const editClientEvent = async (id) => {
    let body = buildCreateClientBody(getCompany());
    validateCreateClient(body);
    let res = await editClient(body, id);
    if(! res.ok){
        throw new Error(res.error);
    }
    
    return res;
}